<template>
  <b-modal :active.sync="isModalActive" has-modal-card :can-cancel="false">
    <div class="modal-card">
      <header class="modal-card-head">
        <h1 class="is-title-header modal-card-title">Rejection Reason</h1>
      </header>
      <section class="modal-card-body">
        <p v-if="data">{{ data.comment_for_rejection }}</p>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-normal" type="button" @click="cancel">
          Close
        </button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import UtilityMixin from "@/mixins/UtilityMixin";

export default {
  name: "SetTimeModal",
  mixins: [UtilityMixin],
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    data: {
      default: null
    }
  },

  data() {
    return {
      isModalActive: false,
      loading: ""
    };
  },

  methods: {
    cancel() {
      this.setTime = null;
      this.$emit("cancel");
    }
  },
  watch: {
    isActive(newValue) {
      this.isModalActive = newValue;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.cancel();
      }
    }
  }
};
</script>
